import moment from "moment";

export function simplifyFriendsList(originalList) {
  return originalList.map((friendObject) => ({
    userId: friendObject.friendshipDetails.userId,
    // email: friendObject.friendship.user.friendshipDetails.email,
    firstName: friendObject.friendshipDetails.firstName,
    lastName: friendObject.friendshipDetails.lastName,
    UserName: friendObject.friendshipDetails.UserName,
    profilePhoto: friendObject.friendshipDetails.profilePhoto,
    friendshipStatus: friendObject.friendshipStatus.message,
  }));
}

export function formatCreatedAt(createdAt) {
  // Get the current date and time
  const now = moment();

  // Calculate the difference in days between now and createdAt
  const diffInDays = now.diff(moment(createdAt), 'days');

  // If createdAt is within the current day, use 'LT' format
  if (diffInDays === 0) {
    return moment(createdAt).format('LT');
  }

  // If createdAt is exactly one day ago, return "Yesterday"
  if (diffInDays === 1) {
    return "Yesterday";
  }

  // If createdAt is within a week (but more than one day ago), return the day of the week
  if (diffInDays > 1 && diffInDays <= 7) {
    return moment(createdAt).format('dddd');
  }

  // If createdAt is more than a week ago, use 'L' format
  return moment(createdAt).format('DD/MM/YYYY');
}

export const formatNumber = (number) => {
  if (number < 1000) {
    return number.toString();
  } else if (number < 1000000) {
    return (number / 1000).toFixed(1) + 'K';
  } else {
    return (number / 1000000).toFixed(1) + 'M';
  }
};

export const formatTime = (time) => {
  const now = moment();
  const diffSeconds = now.diff(moment(time), 'seconds');

  if (diffSeconds < 10) return "just now";
  if (diffSeconds < 60) return `${diffSeconds}sec`;

  const diffMinutes = now.diff(moment(time), 'minutes');
  if (diffMinutes < 60) return `${diffMinutes}min`;

  const diffHours = now.diff(moment(time), 'hours');
  if (diffHours < 24) return `${diffHours}h`;

  const diffDays = now.diff(moment(time), 'days');
  if (diffDays < 30) return `${diffDays}d`;

  const diffMonths = now.diff(moment(time), 'months');
  if (diffMonths < 12) return `${diffMonths}month`;

  const diffYears = now.diff(moment(time), 'years');
  return `${diffYears}yrs`;
};


export const searchAndSortUser = (query, data) => {
  if (!Array.isArray(data)) return [];
  if (query !== '') {
    const lowerCaseQuery = query.toLowerCase();
    const queryWords = lowerCaseQuery.split(' ');

    const filteredData = data.filter(item =>
      queryWords.every(word =>
        (item.firstName.toLowerCase().startsWith(word) || '') +
        (item.lastName.toLowerCase().startsWith(word) || '') +
        ((item.userName ? item.userName : '').toLowerCase().startsWith(word) || '')
      )
    );

    const sortedData = filteredData.sort((a, b) => {
      const scoreA = queryWords.reduce((totalScore, word) => {
        totalScore +=
          ((a.firstName.toLowerCase().startsWith(word) || '') ? 3 : 0) +
          ((a.lastName.toLowerCase().startsWith(word) || '') ? 2 : 0) +
          (((a.userName ? a.userName : '').toLowerCase().startsWith(word) || '') ? 1 : 0);
        return totalScore;
      }, 0);

      const scoreB = queryWords.reduce((totalScore, word) => {
        totalScore +=
          ((b.firstName.toLowerCase().startsWith(word) || '') ? 3 : 0) +
          ((b.lastName.toLowerCase().startsWith(word) || '') ? 2 : 0) +
          (((b.userName ? b.userName : '').toLowerCase().startsWith(word) || '') ? 1 : 0);
        return totalScore;
      }, 0);

      return scoreB - scoreA;
    });

    return sortedData;
  }
};